import { translationBaseKey } from '../../../../decorators/translation-base-key.decorator';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import { QppPensionOptions } from '../../qpp-pension/qpp-pension.options';

@translationBaseKey('qpp-pension-in-salary-dividend-options')
export class QppPensionOptionsInSalaryDividendOptions
  implements Omit<QppPensionOptions,
    'calculationKeyname' |
    'employmentIncome' |
    'currentAge' |
    'qPPApplicationAge' |
    'fiscalYear'
  > {
  @clonePropertyMetadata<QppPensionOptions>(QppPensionOptions, 'deathAge')
  deathAge: number;

  @clonePropertyMetadata<QppPensionOptions>(QppPensionOptions, 'qPPIncreasingRate')
  qPPIncreasingRate: number;

  @clonePropertyMetadata<QppPensionOptions>(QppPensionOptions, 'investmentRate')
  investmentRate: number;
}
